import * as React from 'react';
import {
	AccountPreferences,
	Api,
	createFolder,
	Item as ShareFileItem,
} from '@citrite/sf-api';
import { ModalProps } from '@sharefiledev/flow-web';
import { Modal } from 'antd';
import { t } from '../../../utils';
import { FileListModal } from '../FileListModal';

export interface AddFromShareFileDialogProps extends ModalProps<ShareFileItem[]> {
	disableItems: (item: ShareFileItem) => boolean;
	accountPreferences: AccountPreferences;
	apiConfiguration: Api.Configuration;
	isMultiselect?: boolean;
	hasHomeFolder: boolean;
	onCloseSuccess: (items: ShareFileItem[]) => void;
	onDismiss: () => void;
}

interface State {
	checkedItems?: ShareFileItem[];
}

export class AddFromShareFileDialog extends React.Component<
	AddFromShareFileDialogProps,
	State
> {
	public constructor(props: AddFromShareFileDialogProps) {
		super(props);
		Api.configure(this.props.apiConfiguration);
	}

	public state: State = {
		checkedItems: [],
	};

	private createRootLevelFolders() {
		const rootLevelFolders: ShareFileItem[] = [];

		if (this.props.hasHomeFolder) {
			rootLevelFolders.push(
				createFolder({
					Name: t('personalFolders'),
					Id: 'home',
				})
			);
		}

		rootLevelFolders.push(
			createFolder({
				Name: t('sharedFolders'),
				Id: 'allshared',
			})
		);
		rootLevelFolders.push(
			createFolder({
				Name: t('favorites'),
				Id: 'favorites',
			})
		);
		return rootLevelFolders;
	}

	private onChecked = (checkedItems: ShareFileItem[]) => {
		this.setState({ checkedItems });
	};

	private addSelectedItem = () => {
		this.props.onCloseSuccess(this.state.checkedItems);
	};

	public render() {
		return (
			<Modal
				title={t('addFilesFromSharefile')}
				open
				width={640}
				centered
				okText={t('add')}
				okButtonProps={{ disabled: this.state.checkedItems.length === 0 }}
				onOk={this.addSelectedItem}
				onCancel={this.props.onDismiss}
				{...this.props}
			>
				<FileListModal
					disableItems={this.props.disableItems}
					accountPreferences={this.props.accountPreferences}
					checkedItems={this.state.checkedItems}
					initialItems={this.createRootLevelFolders()}
					checkItems={this.onChecked}
					emptyStateTitle={t('emptyFolder')}
					isMultiselect={false}
				/>
			</Modal>
		);
	}
}
